import { Component, OnInit } from '@angular/core';
import { OidcClientNotification, OidcSecurityService, OpenIdConfiguration, UserDataResult } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../../auth/authentication-service';
import { Router } from '@angular/router';

@Component({
    selector: 'ciam-login',
    templateUrl: './ciam-login.component.html',
    styleUrls: ['./ciam-login.component.css'],
    standalone: false
})
export class CiamLoginComponent implements OnInit {
  configuration$: Observable<OpenIdConfiguration | null> = new Observable<OpenIdConfiguration>();
  userDataChanged$: Observable<OidcClientNotification<any>> = new Observable<OidcClientNotification<any>>();
  userData$: Observable<UserDataResult> = new Observable<UserDataResult>();
  isAuthenticated: boolean = false;
  debug: boolean = false;
  loading: boolean = true;

  constructor(private oidcSecurityService: OidcSecurityService, private authService: AuthenticationService, private router: Router) { }

  ngOnInit() {
    this.oidcSecurityService
      .checkAuth()
      .subscribe(({ isAuthenticated, userData, accessToken }) => {
        this.loading = false;
        this.isAuthenticated = isAuthenticated;

        if (isAuthenticated)
          this.authService.setAuthData(userData.email, accessToken);
      });

    this.configuration$ = this.oidcSecurityService.getConfiguration();
    this.userData$ = this.oidcSecurityService.userData$;
  }

  login() {
    this.oidcSecurityService.authorize();
  }

  refreshSession() {
    this.oidcSecurityService
      .forceRefreshSession()
      .subscribe((result) => console.log(result));
  }

  logout() {
    this.authService.logout();
  }

  logoffAndRevokeTokens() {
    this.oidcSecurityService
      .logoffAndRevokeTokens()
      .subscribe((result) => console.log(result));
  }

  revokeRefreshToken() {
    this.oidcSecurityService
      .revokeRefreshToken()
      .subscribe((result) => console.log(result));
  }

  revokeAccessToken() {
    this.oidcSecurityService
      .revokeAccessToken()
      .subscribe((result) => console.log(result));
  }
}
